module.exports = __webpack_public_path__ + "static/media/EC photo 1.f4d2a725.jpg";